import { Autocomplete, TextField } from "@mui/material";
import React from "react";

const AutoCompleteComponent = ({
    formik,
    value,
    label,
    options,
    onChange,
    error,
    helperText,
    formikField,
    handleSelect,
}) => {

    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            value={value}
            onChange={(e, value) => {
                handleSelect(value) ?? formik.setFieldValue(formikField, value);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    name={formikField}
                    label={label}
                    variant='outlined'
                    onChange={onChange}
                    onBlur={formik.handleBlur}
                    error={error}
                    helperText={helperText}
                    // InputProps={{
                    //     ...params.InputProps,
                    //     endAdornment: (
                    //         <>
                    //             {locationLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    //             {params.InputProps.endAdornment}
                    //         </>
                    //     ),
                    // }}
                    fullWidth
                />
            )}
        />
    );
};

export default AutoCompleteComponent;
